// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { forwardRef, memo, useEffect, useImperativeHandle, useState } from 'react'
import './daysOfWeekSelect.scss'
import classNames from 'classnames'
import moment from 'moment-timezone'
import InfoCircle from '../info-circle/InfoCircle'
import { getDaysOfWeekFromAbbreviationArr } from '../../utils/common'
import { adjustDaysOfWeekByPrevSelectedValue, compareDaysOfWeekLists } from './helper'

const INITIAL_DAY_OF_WEEKS_LIST = [
  { value: 'Sun', isActive: false },
  { value: 'Mon', isActive: false },
  { value: 'Tue', isActive: false },
  { value: 'Wed', isActive: false },
  { value: 'Thu', isActive: false },
  { value: 'Fri', isActive: false },
  { value: 'Sat', isActive: false },
]

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getActiveDays = (daysOfWeekList) => daysOfWeekList.filter((day) => day.isActive).map((day) => day.value)

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getDefaultWeekDaysList = (list, customTimeZone, isAlreadyChangedByUser) => {
  if (isAlreadyChangedByUser) {
    return list
  }
  const currentWeekDayAbbr = moment(new Date()).parseZone().tz(customTimeZone).format('ddd')
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return list.map((day) => ({
    ...day,
    isActive: day.value === currentWeekDayAbbr,
  }))
}

const DaysOfWeekSelect = memo(
  forwardRef(
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    ({ error, setError, className, prevSelectedDays, repeatDays, setPrevSelectedDays, calendarTimeZone }, ref) => {
      const [daysOfWeek, setDaysOfWeek] = useState(
        getDefaultWeekDaysList(INITIAL_DAY_OF_WEEKS_LIST, calendarTimeZone, !!prevSelectedDays?.length),
      )

      useEffect(() => {
        if (prevSelectedDays.length) {
          setDaysOfWeek(adjustDaysOfWeekByPrevSelectedValue(daysOfWeek, prevSelectedDays))
        }
      }, [prevSelectedDays])

      const activeDays = getActiveDays(daysOfWeek)

      useImperativeHandle(ref, () => ({
        getActiveDays: () => activeDays,
        isRepeatDaysWasChanged: () => {
          const selectedDaysList = getDaysOfWeekFromAbbreviationArr(activeDays)
          return compareDaysOfWeekLists(selectedDaysList, repeatDays)
        },
      }))

      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const onDayClick = (value) => {
        setError('')
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        setDaysOfWeek((prevValue) => {
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          const newValue = prevValue.map((dayOfWeek) =>
            dayOfWeek.value === value ? { ...dayOfWeek, isActive: !dayOfWeek.isActive } : dayOfWeek,
          )
          setPrevSelectedDays(getDaysOfWeekFromAbbreviationArr(getActiveDays(newValue)))
          return newValue
        })
      }

      return (
        <div className={classNames('days-of-week-select-container', { className })}>
          <div className='days-of-week-select-circles'>
            {/*
             // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
            {daysOfWeek.map(({ value, isActive }) => (
              // @ts-expect-error TS2741 -- MIGRATION: not approved, fix when encountered
              <InfoCircle key={value} value={value} isActive={isActive} onClick={onDayClick} />
            ))}
          </div>
          <span className='days-of-week-select-error-message'>{error}</span>
        </div>
      )
    },
  ),
)

export default DaysOfWeekSelect
